/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBenutzerDetailDto } from '../../models/lexplus-benutzer-detail-dto';

export interface BenutzerverwaltungControllerFindOneV1$Params {
  id: string;
}

export function benutzerverwaltungControllerFindOneV1(http: HttpClient, rootUrl: string, params: BenutzerverwaltungControllerFindOneV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBenutzerDetailDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungControllerFindOneV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBenutzerDetailDto>;
    })
  );
}

benutzerverwaltungControllerFindOneV1.PATH = '/v1/benutzerverwaltung/{id}';
